<!--The content below is only a placeholder and can be replaced.-->

@if (isLoggedIn()) {
  <div>
    <app-nav></app-nav>
    <router-outlet></router-outlet>
    <app-open-requests class="request-count"></app-open-requests>
  </div>
}

@if (!isLoggedIn()) {
  <div>
    <app-login></app-login>
  </div>
}
